"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractVariantCommand = void 0;
const AbstractCommand_1 = require("../AbstractCommand");
class AbstractVariantCommand extends AbstractCommand_1.AbstractCommand {
    constructor(api, appId) {
        super(api);
        this.appId = appId;
    }
}
exports.AbstractVariantCommand = AbstractVariantCommand;
//# sourceMappingURL=AbstractVariantCommand.js.map